
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import './bootstrap';

import 'regenerator-runtime'

import Vue from 'vue';

import 'jquery-mask-plugin';

//---------------------

import 'vue-carousel';
import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

import Axios from 'axios'
window.Axios = Axios

//---------------------

//---------------------

import VueSocialSharing from 'vue-social-sharing';
Vue.use(VueSocialSharing);

//---------------------

import money from 'v-money';
Vue.use(money, {precision: 2, decimal: ',',  thousands: '.', prefix: 'R$ '});

//---------------------

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);

import VueHtmlToPaper from 'vue-html-to-paper';
Vue.use(VueHtmlToPaper, 
    {
        name: '_blank',
        specs: [
            'fullscreen=yes',
            'titlebar=yes',
            'scrollbars=yes'
        ],
        styles: [
            'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
            'https://unpkg.com/kidlat-css/css/kidlat.css',
            ''
        ]
    }
)

//---------------------

import MaskedInput from 'vue-text-mask'
Vue.component('masked-input', MaskedInput);

//---------------------

import './plugins/vee-validate';

//---------------------

import { DateTime } from 'luxon';

window.luxon = DateTime

//---------------------

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard);

import 'vue2-datepicker';
import Datepicker from 'vue2-datepicker'
Vue.use(Datepicker)


import mask from "vanilla-masker"
window.VMasker = mask

import isjs from "is_js"
window.is = isjs


// Filters

import { truncate } from './filters/truncate';

Vue.filter('truncate', truncate)

Vue.filter('currency', function (value) {
    if (!value) {
        console.error('Empty value passed to currency filter');
        return ''
    }
    
    if(typeof value == 'string') {
        value = value.replace(",", ".");
    }

    const formatter = new Intl.NumberFormat(
        window.i18n.locale.replace('_', '-'), 
        { 
            style: 'currency', 
            currency: window.currency
        }
    )

    return formatter.format(value)
});

//---------------------

import VueRecaptcha from 'vue-recaptcha';
window.VueRecaptcha = VueRecaptcha

//---------------------

import AvatarCropper from "vue-avatar-cropper"
window.AvatarCropper = AvatarCropper

//---------------------

import queryString from 'query-string';
window.queryString = queryString;

import DTKEstadio from './components/Estadio.vue'
Vue.component('dtk-estadio', DTKEstadio)

import Setores from './components/Setores.vue'
Vue.component('dtk-estadio-canvas', Setores)

import './components/register';

import './plugins/localization';
import './plugins/mask';
import './plugins/device';

import validaCPF from './utils/validators/Validators';
window.validaCPF = validaCPF

window.Vue = Vue
console.log('Vue loaded', Vue)